import { Controller } from "stimulus"

// A side panel that any element on the page can open:
//   <a href="#" data-drawer-open="feedback-drawer">Share feedback</a>
// Optional data-drawer-fill='{"field[name]": "value"}' presets fields inside it.
// Escape or a data-action="drawer#close" button closes it. Opening dispatches
// "drawer:opened" on window so controllers inside can refresh themselves.
export default class extends Controller {
  openFromTrigger(event) {
    const trigger = event.target.closest("[data-drawer-open]")
    if (!trigger || trigger.dataset.drawerOpen !== this.element.id) return

    event.preventDefault()
    this.lastTrigger = trigger
    this.open(trigger)
  }

  open(trigger = null) {
    this.element.hidden = false
    this.setExpanded(true)
    this.fill(trigger)
    window.dispatchEvent(new CustomEvent("drawer:opened", { detail: { id: this.element.id, trigger } }))
    requestAnimationFrame(() => {
      // On touch screens, focusing a field would pop the keyboard over the panel.
      const touch = window.matchMedia("(pointer: coarse)").matches
      const field = !touch && this.element.querySelector("textarea, input:not([type=hidden]):not([type=radio]):not([type=file])")
      ;(field || this.element).focus({ preventScroll: true })
    })
  }

  close() {
    if (this.element.hidden) return

    this.element.hidden = true
    this.setExpanded(false)
    this.resetIfDone()
    if (this.lastTrigger && this.lastTrigger.isConnected) this.lastTrigger.focus({ preventScroll: true })
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.element.hidden) this.close()
  }

  // After a successful send, closing brings back a fresh form for next time.
  resetIfDone() {
    this.element.querySelectorAll("[data-drawer-done] [data-drawer-reset-link]").forEach(link => link.click())
  }

  fill(trigger) {
    if (!trigger || !trigger.dataset.drawerFill) return

    let values
    try {
      values = JSON.parse(trigger.dataset.drawerFill)
    } catch (_error) {
      return
    }
    Object.entries(values).forEach(([name, value]) => {
      this.element.querySelectorAll(`[name="${CSS.escape(name)}"]`).forEach(field => {
        if (field.type === "radio" || field.type === "checkbox") {
          if (field.value !== String(value)) return
          field.checked = true
          field.dispatchEvent(new Event("input", { bubbles: true }))
        } else if (!field.value) {
          field.value = value
        }
      })
    })
  }

  setExpanded(expanded) {
    document.querySelectorAll(`[data-drawer-open="${this.element.id}"]`).forEach(el => {
      el.setAttribute("aria-expanded", String(expanded))
    })
  }
}
